import React from "react";
import { FormDataConsumer, Loading } from "react-admin";
import { useMentorAvailabilityData, useSelectedSlot } from "../hooks";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import { Error } from "../../MyProfile/Error";
import AppProvider from "../../../Components/bootstrap";
import moment from "moment";
import { SelectInput } from "react-admin";
import { DateInput } from "../react-admin-date-inputs";
import { Form } from "react-final-form";
import { Grid } from "@material-ui/core";

function getSlots(date, duration, a, appointmentData) {
  
  if (date && a.loaded) {
    const { vacationMode, vacationStartDate, vacationEndDate } = a.data;

    if (
      vacationMode &&
      moment(date).isBetween(vacationStartDate, vacationEndDate)
    ) {
      return [{ name: "Not Available", id: 1 }];
    }

    let slots = [],
      startTime = "",
      stopTime = "";
    switch (moment(date).day()) {
      case 1:
        startTime = moment(a.data.mondayStartTime, "HH:mm");
        stopTime = moment(a.data.mondayStopTime, "HH:mm");
        break;
      case 2:
        startTime = moment(a.data.tuesdayStartTime, "HH:mm");
        stopTime = moment(a.data.tuesdayStopTime, "HH:mm");
        break;
      case 3:
        startTime = moment(a.data.wednesdayStartTime, "HH:mm");
        stopTime = moment(a.data.wednesdayStopTime, "HH:mm");
        break;
      case 4:
        startTime = moment(a.data.thursdayStartTime, "HH:mm");
        stopTime = moment(a.data.thursdayStopTime, "HH:mm");
        break;
      case 5:
        startTime = moment(a.data.fridayStartTime, "HH:mm");
        stopTime = moment(a.data.fridayStopTime, "HH:mm");
        break;
      case 6:
        startTime = moment(a.data.saturdayStartTime, "HH:mm");
        stopTime = moment(a.data.saturdayStopTime, "HH:mm");
        break;
      case 0:
        startTime = moment(a.data.sundayStartTime, "HH:mm");
        stopTime = moment(a.data.sundayStopTime, "HH:mm");
        break;
      default:
        startTime = "00:00";
        stopTime = "00:00";
    }

    let slot = startTime,
      ctr = 0;

    // if (
    //   moment(startTime).format("HH:mm") !== "00:00" &&
    //   moment(stopTime).format("HH:mm") !== "00:00"
    // ) {
    while (slot < stopTime) {
      if (moment(date) === moment() && moment(slot).isAfter(moment())) {
        slots.push({
          name: moment(slot).format("HH:mm"),
          id: ctr++,
        });
      }
      if (moment(date) !== moment()) {
        slots.push({
          name: moment(slot).format("HH:mm"),
          id: ctr++,
        });
      }
      slot = moment(slot).add(duration, "m");
    }

    //   (moment(appointment.appointmentDate).format("L") ===
    //   moment(date).format("L") &&
    //   appointment.appointmentTime === slot.name) ||
    // (moment(date).format("L") === moment(new Date()).format("L") &&
    //   parseInt(slot.name.substring(0, 2)) <= new Date().getHours() + 2)

    slots.forEach((slot, index) => {
      appointmentData.data.forEach((appointment) => {
        if (
          moment(appointment.appointmentDate).format("L") ===
            moment(date).format("L") &&
          appointment.appointmentTime === slot.name
        ) {
          slot.isDisabled = true;
        }
      });

      // slot.isDisabled = Found ? true : false;
      /************2 hr logic****************/

      if (
        moment(date).format("L") === moment(new Date()).format("L") &&
        parseInt(slot.name.substring(0, 2)) <= new Date().getHours() + 2
      ) {
        slot.isDisabled = true;
      }
      /************2 hr logic****************/

      /******** 60 duration logic **********/
      //   appointmentData.data.forEach((appointment, index) => {
      //     if (
      //       appointment.appointmentTime.substring(0, 2) ===
      //         slot.name.substring(0, 2) &&
      //       appointment.appointmentTime.substring(3) === "30" &&
      //       duration === 60
      //     ) {
      //       slot.isDisabled = true;
      //     }
      // });
    });
    /******** 60 duration logic **********/

    return slots;
    // } else {
    //   return [{ name: "Not Available", id: 1 }];
    // }
  }
  return [{ name: "Select a Date" }];
}

export const SelectSlot = ({ aid }) => {
  const [duration, setDuration] = React.useState(30);
  const { selectedSlot } = useSelectedSlot();
  const { availabilityData, appointmentData } = useMentorAvailabilityData(
    aid,
    duration
  );
 
  const handleDuration = (event, newDuration) => {
    setDuration(newDuration);
  };

  const handleSubmit = async (values) => {
    values = { duration, ...values };
    selectedSlot(values);
  };

  const ui = (
    <AppProvider>
      {!availabilityData.loaded ? (
        <Loading />
      ) : (
        <React.Fragment>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="flex-start"
          >
            <Grid item>
              <ToggleButtonGroup
                size="small"
                value={duration}
                onChange={handleDuration}
                exclusive
              >
                <ToggleButton value={30} aria-label="30 mins">
                  {" "}
                  30 Mins{" "}
                </ToggleButton>
                <ToggleButton value={60} aria-label="60 mins">
                  {" "}
                  60 mins{" "}
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item>
              <Form
                onSubmit={handleSubmit}
                render={({
                  handleSubmit,
                  form,
                  submitting,
                  pristine,
                  values,
                }) => {
                  return (
                    <form>
                      <Grid
                        container
                        direction="row"
                        alignItems="flex-end"
                        spacing={2}
                      >
                        <Grid item style={{ marginBottom: "18px" }}>
                          <DateInput
                            source="appointmentDate"
                            label="Start date"
                            disableToolbar
                            required={true}
                            onChange={(e) => {
                            }}
                            isRequired={true}
                            options={{
                              format: "dd/MM/yyyy",
                              minDate: moment(),
                            }}
                          />
                        </Grid>
                        <Grid item>
                          <FormDataConsumer>
                            {({ formData, ...rest }) => (
                              <SelectInput
                                source="appointmentTime"
                                label="Select Slot"
                                variant="standard"
                                style={{ paddingBottom: 0 }}
                                choices={getSlots(
                                  formData.appointmentDate,
                                  duration,
                                  availabilityData,
                                  appointmentData
                                )}
                                optionValue="name"
                                onChange={handleSubmit}
                                disableValue="isDisabled"
                                {...rest}
                              />
                            )}
                          </FormDataConsumer>
                        </Grid>
                      </Grid>
                    </form>
                  );
                }}
              />
            </Grid>
          </Grid>
        </React.Fragment>
      )}
    </AppProvider>
  );

  if (availabilityData.error) {
    return <Error />;
  }
  return ui;
};
